export default {
  // login: '/admin/jg/login',
  // 获取图片验证码
  getAdVerifyCode: '/admin/getVerifyCode',
  // 短信验证码
  sendAdSms: '/admin/jg/sendSms',
  // 短信登录
  smsLogin: '/admin/jg/smsLogin',
  // logout: '/business/jg/loginOut',
  getRegion: '/business/jgDic/selectCity',
  selectJgUserByList: '/business/jgUser/selectJgUserByList',
  selectJgRoleByList: '/business/jgRole/selectJgRoleByList',
  updatePassword: '/business/jgUser/updatePassword',
  // 修改密码(无须输入旧密码)
  updateInitPassword: '/business/jgUser/updateInitPassword',
  // 查询数据字典列表
  selectDicByList: '/business/jgDic/selectDicByList',
  getRoleList: '/business/yhRole/selectYhRoleByList',
  // 短信验证码
  sendSms: '/business/jg/sendSms',
  getAnswerApiSimple: '/business/jgGuide/getAnswerApiSimple',
  // 七牛
  uploadToken: '/business/jgQiniu/getToken',
  uploadQiniup: 'https://upload.qiniup.com',
  // 图片验证码
  getVerifyCode: '/admin/getVerifyCode',
  getVerifyCodeIn: '/business/jg/getVerifyCode',
  getLoginCode: '/admin/yh/login',
  logout: '/business/jg/loginOut',
  login: '/business/jg/login',
  // 客户申请注册
  registerCustomer: '/admin/customer/registerCustomer',
  registerSendSms: '/admin/sendSms',
  // 获取客户有效期
  selectCustomerInfo: '/admin/customer/selectCustomerInfo',
  getJwtAccessToken: '/business/cozeAi/getJwtAccessToken'
}
